/**
 * Geolocation helper (Day 14).
 *
 * Location is collected ONLY for the shift check-in/out workflow and geofence /
 * compliance policy — never for background tracking. A single one-shot fix is
 * requested at the moment of check-in/out and is not retained beyond the action.
 */

export async function getCurrentPosition({ timeout = 8000, highAccuracy = true } = {}) {
  if (typeof navigator === 'undefined' || !navigator.geolocation) {
    return { ok: false, reason: 'UNSUPPORTED' };
  }
  return new Promise((resolve) => {
    navigator.geolocation.getCurrentPosition(
      (pos) => resolve({
        ok: true,
        lat: pos.coords.latitude,
        lng: pos.coords.longitude,
        accuracy: pos.coords.accuracy,
      }),
      (err) => resolve({
        ok: false,
        reason: err.code === 1 ? 'DENIED' : err.code === 3 ? 'TIMEOUT' : 'UNAVAILABLE',
      }),
      { enableHighAccuracy: highAccuracy, timeout, maximumAge: 0 }
    );
  });
}
